/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const USER_PROFILE_FEATURE = 'userProfile';
export const USER_PROFILE_CORE_FEATURE = 'userProfileCore';
